export const environment = {
  production: true,
  version: '6.3.0',
  build: '.6'
};
